<ac-card>
  <ac-card-content>
    <div class="purchase-dialog">
      <app-purchase-dialog-header
        (back)="back.emit()"
        (close)="close.emit()"
      />

      <div class="rb">
        <!-- Hero icon -->
        <div class="rb__icon-wrapper" aria-hidden="true">
          <ac-icon iconKey="hr:bolt" [size]="36" />
        </div>

        <!-- Title + body -->
        <div class="rb__header">
          <h2 class="ac-headline-sm rb__title">{{ percentage() }}% Gains Boost</h2>
          @if (maxAmount(); as max) {
            <p class="ac-body-md rb__subtitle">
              You currently have a {{ percentage() }}% Gains Boost active on your purchase amount up to {{ max | currency : 'USD' : 'symbol' : '1.2-2' }}
            </p>
          } @else {
            <p class="ac-body-md rb__subtitle">
              You currently have a {{ percentage() }}% Gains Boost active
            </p>
          }
        </div>

        <!-- Continue button -->
        <button class="rb__continue-btn" type="button" (click)="back.emit()">
          Continue to Buy Coins
        </button>

        <!-- Footer warning. Intentionally suppressed when there is no max —
             native shows it unconditionally, but the copy makes no sense
             without a max amount. Do not "fix" this back to match native. -->
        @if (maxAmount()) {
          <p class="ac-body-sm rb__footer">
            Any excess amount above the max eligible boost amount will not be boosted.
          </p>
        }
      </div>
    </div>
  </ac-card-content>
</ac-card>
